import React from 'react'

export const OptimizationsInovations = ({ className }: { className: SVGElement['className'] }) => (
  <svg
    width="1080"
    zoomAndPan="magnify"
    viewBox="0 0 810 809.999993"
    height="1080"
    preserveAspectRatio="xMidYMid meet"
    version="1.0"
    className={className}
  >
    <defs>
      <clipPath id="478e225c00">
        <path
          d="M 40.835938 465 L 747 465 L 747 769.085938 L 40.835938 769.085938 Z M 40.835938 465 "
          clipRule="nonzero"
        />
      </clipPath>
      <clipPath id="0d4979e553">
        <path
          d="M 63 40.835938 L 769.085938 40.835938 L 769.085938 333 L 63 333 Z M 63 40.835938 "
          clipRule="nonzero"
        />
      </clipPath>
      <clipPath id="5bb5bef06d">
        <path d="M 34 456 L 121 456 L 121 544 L 34 544 Z M 34 456 " clipRule="nonzero" />
      </clipPath>
      <clipPath id="19d2f1bf32">
        <path
          d="M 20.441406 464.085938 L 106.382812 449.082031 L 120.25 528.507812 L 34.308594 543.511719 Z M 20.441406 464.085938 "
          clipRule="nonzero"
        />
      </clipPath>
      <clipPath id="86c5316451">
        <path
          d="M 63.355469 456.59375 L 120.136719 528.527344 L 34.308594 543.511719 Z M 63.355469 456.59375 "
          clipRule="nonzero"
        />
      </clipPath>
      <clipPath id="29774a1e3c">
        <path d="M 689 251 L 776 251 L 776 340 L 689 340 Z M 689 251 " clipRule="nonzero" />
      </clipPath>
      <clipPath id="f0201ad7fc">
        <path
          d="M 802.902344 322.625 L 715.917969 355.554688 L 688.8125 283.957031 L 775.796875 251.023438 Z M 802.902344 322.625 "
          clipRule="nonzero"
        />
      </clipPath>
      <clipPath id="4454cf163d">
        <path
          d="M 759.519531 339.046875 L 689.03125 283.871094 L 775.796875 251.023438 Z M 759.519531 339.046875 "
          clipRule="nonzero"
        />
      </clipPath>
    </defs>
    <path
      fill="#ffffff"
      d="M 477.828125 320.027344 L 526.382812 320.027344 L 526.382812 477.828125 L 477.828125 477.828125 Z M 477.828125 320.027344 "
      fillOpacity="1"
      fillRule="nonzero"
    />
    <path
      fill="#ffffff"
      d="M 380.71875 356.441406 L 429.273438 356.441406 L 429.273438 477.828125 L 380.71875 477.828125 Z M 380.71875 356.441406 "
      fillOpacity="1"
      fillRule="nonzero"
    />
    <path
      fill="#ffffff"
      d="M 283.609375 404.996094 L 332.164062 404.996094 L 332.164062 477.828125 L 283.609375 477.828125 Z M 283.609375 404.996094 "
      fillOpacity="1"
      fillRule="nonzero"
    />
    <path
      fill="#ffffff"
      d="M 172.394531 332.855469 C 168.925781 344.921875 160.003906 354.441406 148.445312 358.191406 L 115.914062 368.761719 C 114.496094 380.648438 113.667969 392.726562 113.667969 404.996094 C 113.667969 417.269531 114.496094 429.347656 115.914062 441.21875 L 148.445312 451.792969 C 160.003906 455.542969 168.925781 465.070312 172.394531 477.125 C 173.523438 481.035156 174.738281 484.894531 176.039062 488.71875 C 180.09375 500.636719 178.285156 513.84375 171.023438 523.992188 L 151.628906 551.109375 C 163.609375 572.535156 178.125 592.273438 194.792969 609.933594 L 224.121094 599.628906 C 235.640625 595.585938 248.261719 597.855469 257.914062 605.539062 C 260.960938 607.96875 264.066406 610.324219 267.222656 612.59375 C 277.191406 619.765625 283.136719 631.542969 282.992188 644.140625 L 282.652344 673.773438 C 304.660156 684.136719 328.148438 691.773438 352.714844 696.300781 L 368.410156 673.261719 C 375.425781 662.957031 386.898438 657.082031 399.039062 657.386719 C 401.015625 657.457031 403.007812 657.480469 404.996094 657.480469 C 406.988281 657.480469 408.96875 657.457031 410.945312 657.410156 C 423.085938 657.105469 434.554688 662.992188 441.570312 673.285156 L 457.265625 696.324219 C 481.835938 691.796875 505.324219 684.164062 527.320312 673.796875 L 526.980469 644.164062 C 526.832031 631.566406 532.78125 619.792969 542.746094 612.617188 C 545.902344 610.347656 549.011719 607.992188 552.058594 605.566406 C 561.707031 597.882812 574.34375 595.597656 585.851562 599.652344 L 615.179688 609.960938 C 631.84375 592.296875 646.363281 572.558594 658.34375 551.136719 L 638.945312 524.015625 C 631.6875 513.871094 629.878906 500.664062 633.933594 488.742188 C 635.230469 484.917969 636.445312 481.058594 637.574219 477.148438 C 641.046875 465.085938 649.96875 455.566406 661.523438 451.816406 L 694.054688 441.242188 C 695.5 429.347656 696.324219 417.269531 696.324219 404.996094 C 696.324219 392.726562 695.5 380.648438 694.078125 368.761719 L 661.546875 358.191406 C 649.992188 354.441406 641.070312 344.910156 637.597656 332.855469 C 636.46875 328.949219 635.257812 325.089844 633.957031 321.265625 C 629.902344 309.34375 631.710938 296.136719 638.96875 285.988281 L 658.367188 258.871094 C 646.386719 237.449219 631.871094 217.710938 615.203125 200.046875 L 585.875 210.355469 C 574.355469 214.394531 561.730469 212.125 552.082031 204.441406 C 549.035156 202.015625 545.925781 199.660156 542.769531 197.390625 C 532.804688 190.214844 526.859375 178.441406 527.003906 165.839844 L 527.34375 136.210938 C 505.324219 125.832031 481.835938 118.195312 457.265625 113.667969 L 441.570312 136.707031 C 434.554688 147.003906 423.085938 152.890625 410.945312 152.585938 C 408.980469 152.539062 406.988281 152.511719 404.996094 152.511719 C 403.007812 152.511719 401.027344 152.539062 399.050781 152.585938 C 386.910156 152.890625 375.441406 147.003906 368.421875 136.707031 L 352.726562 113.667969 C 328.160156 118.195312 304.671875 125.832031 282.675781 136.199219 L 283.015625 165.828125 C 283.160156 178.429688 277.214844 190.203125 267.246094 197.378906 C 264.09375 199.660156 260.984375 202.003906 257.9375 204.429688 C 248.289062 212.113281 235.652344 214.394531 224.144531 210.34375 L 194.816406 200.035156 C 178.148438 217.699219 163.632812 237.433594 151.652344 258.859375 L 171.050781 285.976562 C 178.308594 296.125 180.117188 309.332031 176.0625 321.253906 C 174.738281 325.089844 173.523438 328.960938 172.394531 332.855469 Z M 404.996094 210.777344 C 512.265625 210.777344 599.214844 297.726562 599.214844 404.996094 C 599.214844 512.265625 512.265625 599.214844 404.996094 599.214844 C 297.726562 599.214844 210.777344 512.265625 210.777344 404.996094 C 210.777344 297.726562 297.726562 210.777344 404.996094 210.777344 Z M 404.996094 210.777344 "
      fillOpacity="1"
      fillRule="nonzero"
    />
    <g clipPath="url(#478e225c00)">
      <path
        fill="#ffffff"
        d="M 65.113281 465.691406 L 40.835938 538.523438 L 64.726562 534.542969 C 118.234375 675.011719 254.355469 769.15625 404.996094 769.15625 C 557.082031 769.15625 694.492188 673.273438 746.90625 530.570312 L 724.125 522.207031 C 675.191406 655.394531 546.945312 744.878906 404.996094 744.878906 C 266.046875 744.878906 140.421875 659.011719 89.269531 530.449219 L 113.667969 526.382812 Z M 65.113281 465.691406 "
        fillOpacity="1"
        fillRule="nonzero"
      />
    </g>
    <g clipPath="url(#0d4979e553)">
      <path
        fill="#ffffff"
        d="M 404.996094 40.835938 C 252.914062 40.835938 115.503906 136.722656 63.085938 279.421875 L 85.871094 287.785156 C 134.804688 154.601562 263.046875 65.113281 404.996094 65.113281 C 542.648438 65.113281 667.203125 149.40625 719.253906 275.964844 L 696.324219 283.609375 L 757.019531 332.164062 L 769.15625 259.332031 L 742.320312 268.28125 C 686.929688 131.828125 553.039062 40.835938 404.996094 40.835938 Z M 404.996094 40.835938 "
        fillOpacity="1"
        fillRule="nonzero"
      />
    </g>
  </svg>
)
